<template>
  <div>
    <DashboardBlock v-if="isLoading" v-for="index in 3" :key="index">
      <template slot="content">
        <Preloader type="small" class="content__preloader" />
      </template>
    </DashboardBlock>
    <DashboardBlock
      v-if="isVisible(block) && !isLoading"
      v-for="block in blocks"
      :key="block.title"
      :title="block.title"
      :metric="{ ...block.metric, value: analyticsData[block.metric.value] }"
      type="metric"
    >
      <template v-if="block.title === 'Смены всех сотрудников'" slot="metric-button">
        <div class="dashboard-block__button_view-more">
          <button type="button" @click="goToWorkAnalytics">
            <i class="fa fa-eye fa-fw" />
            Смотреть
          </button>
        </div>
      </template>
    </DashboardBlock>
  </div>
</template>

<script>
import DashboardBlock from '@/_shared/components/ui/DashboardBlock';
import Preloader from '@/_shared/components/ui/Preloader';
import { analyticsService } from '@/_shared/api-services';
import { useRoleIdentifier } from '@/_shared/mixins';
import { personalArea } from "@/user/constants";
export default {
  mixins: [useRoleIdentifier],
  props: {
    datesRange: {
      type: Array,
      required: true,
    },
  },
  components: {
    DashboardBlock,
    Preloader,
  },
  data() {
    return {
      isLoading: true,
      analyticsData: null,
    };
  },
  watch: {
    async datesRange() {
      await this.getMetrics();
    }
  },
  computed: {
    blocks() {
      return personalArea.metrics;
    },
  },
  methods: {
    async getMetrics() {
      this.isLoading = true;
      const [startDate, endDate] = this.datesRange;
      const params = {
        mode: 'single_user',
        from: startDate.toLocaleString('sv'),
        to: endDate.toLocaleString('sv'),
      };
      await analyticsService.getForWork(params).then(({ data }) => {
        let workingHours = 0;
        let autoEndedShifts = 0;
        let endedProducts = 0;
        if (data.record !== null) {
          workingHours = data.record.number_of_working_hours || 0;
          autoEndedShifts = data.record.auto_ended_shifts.length;
          endedProducts = data.record.ended_products || 0;
        }
        this.analyticsData = {
          number_of_working_hours: workingHours,
          auto_ended_shifts: autoEndedShifts,
          ended_products: endedProducts,
        };
        this.isLoading = false;
      });
    },
    isVisible(block) {
      if (block.title !== 'Смены всех сотрудников') {
        return true;
      }
      return !!this.checkVipRole();
    },
    goToWorkAnalytics() {
      this.$router.push('/analytics/work');
    },
  },
};
</script>

<style scoped>
.dashboard-block__button_view-more {
  padding-top: 1.25em;
}
.dashboard-block__button_view-more > button {
  border-radius: 4px;
  border: 1px #08c solid;
  padding: 8px 16px;
  background: transparent;
  color: #08c;
}
.dashboard-block__button_view-more > button:hover,
.dashboard-block__button_view-more > button:focus {
  color: #fff;
  background: #08c;
  transition: 0.3s;
  cursor: pointer;
}
.content__preloader {
  height: 15vh;
}
</style>



// WEBPACK FOOTER //
// src/user/components/personal-area/MetricBlocks.vue